<template>
  <div class="top-warp">
    <div class="data-box">
      <div class="top-title">华盟值得您信赖
        <div class="bgDot-box">
          <hm-img type="icons" imgName="bg_dot" imgClass="bgDot"/>
        </div>
      </div>
      <div>
        <!-- <a-row type="flex">
          <a-col :span="12" class="data-item">
            <div class="num">36</div>
            <div class="desc">业务覆盖全国税区</div>
          </a-col>
          <a-col :span="12" class="data-item">
            <div class="num">
              200 <span class="plus">+</span>
            </div>
            <div class="desc">公司员工总数</div>
          </a-col>
          <a-col :span="8" class="data-item">
            <div class="num">100 <span class="plus">+</span></div>
            <div class="desc">专家及研发团队</div>
          </a-col>
          <a-col :span="8" class="data-item">
            <div class="num">70 <span class="plus">+</span></div>
            <div class="desc">咨询交付团队</div>
          </a-col>
          <a-col :span="8" class="data-item">
            <div class="num">25 <span class="plus">+</span></div>
            <div class="desc">专业奖项累计</div>
          </a-col>
        </a-row> -->
        <a-row class="card-warp">
          <a-col :span="24" class="card-box info margin-b-20">
            <div class="card-content">
              <div class="card-title">专业团队引领</div>
              <p>国际四大专家+大型企业税务管理专家，拥有丰富的税收政策分析及税务数智化转型经验</p>
              <div class="card-jump" @click="jumpTo('/product/newTaxera')">
                浏览华盟介绍<hm-img class="jump-icon" type="icons" imgName="card-arrow" imgClass="ca-img"/>
              </div>
            </div>
          </a-col>
          <a-col :span="24" class="card-box solution margin-b-20">
            <div class="card-content">
              <div class="card-title">行业解决方案</div>
              <p>针对不同行业提供定制化的解决方案，涵盖制造、零售、物流等多个领域，满足各行业税务运营需求</p>
              <div class="card-jump" @click="jumpTo('/case')">
                了解行业案例<hm-img class="jump-icon" type="icons" imgName="card-arrow" imgClass="ca-img"/>
              </div>
            </div>
          </a-col>
          <a-col :span="24" class="card-box contact">
            <div class="card-content">
              <div class="card-title">卓越服务体验</div>
              <p>我们坚持客户至上，配备专业的交付团队及敬业的运营团队，7*24小时全国专属客户成功团队提供“咨询   产品   服务”端到端服务</p>
              <div class="card-jump" @click="jumpTo('/about')">
                获取联系方式<hm-img class="jump-icon" type="icons" imgName="card-arrow" imgClass="ca-img"/>
              </div>
            </div>
          </a-col>
        </a-row>
        <div class="reward">
          <hm-img type="images" imgName="reward-h5"  imgClass="reward-img"/>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: '',
    props: {},
    components: {},
    data () {
      return {
       
      }
    },
    created () {
  
    },
    methods: {
      jumpTo (path) {
        this.$router.push(path)
      }
    }
  }
  </script>

  <style scoped lang='less'>
  .top-warp {
    // background-color: #fff;
    padding-bottom: 80px;
    .data-box {
      .margin-t-80 {
        margin-top: 80PX;
      }
      .margin-b-20 {
        margin-bottom: 20PX;
      }
      // width: 1200PX;
      margin: 0 auto;
      .top-title {
        margin: 0 auto;
        font-size: 20PX;
        color: #292F3A;
        letter-spacing: 0;
        text-align: center;
        line-height: 54PX;
        font-weight: 600;
        margin-bottom: 16PX;
        // padding: 80PX 0;
        width: 220PX;
        
        position: relative;
        .bgDot-box {
          position: absolute;
          right: 30PX;
          top: -13PX;
        }
      }
      .data-item {
        text-align: center;
        margin-top: 24PX;
        .num {
          font-size: 28PX;
          color: #3E77FF;
          letter-spacing: 0;
          text-align: center;
          line-height: 34PX;
          font-weight: 600;
          position: relative;
          display: inline;
          margin-bottom: 12PX;
        }
        .plus {
          position: absolute;
          top: -4PX;
          font-size: 18PX;
        }
        .desc {
          font-size: 16PX;
          color: #848D9E;
          letter-spacing: 0;
          text-align: center;
          line-height: 14PX;
          font-weight: 400;
          margin-top: 12PX;
        }
      }
      .card-warp {
        padding: 40PX 20PX;
      }
      .card-flex {
        justify-content: space-between;
        margin-top: 56PX;
      }
      .card-box {
        // width: 374PX;
        padding: 24PX;
        height: 196PX;
        position: relative;
        // margin-bottom: 20PX;
        .card-title {
          font-size: 16PX;
          color: #263D76;
          letter-spacing: 0;
          line-height: 21PX;
          font-weight: 600;
        }
        p {
          margin-top:24PX;
          font-size: 14PX;
          color: #6E788B;
          letter-spacing: 0;
          text-align: justify;
          line-height: 24PX;
          font-weight: 400;
        }
        .card-jump {
          font-size: 12PX;
          color: #3E77FF;
          letter-spacing: 0;
          line-height: 24PX;
          font-weight: 400;
          position: absolute;
          // top: 28PX;
          bottom: 20PX;
          cursor: pointer;
        }
        .jump-icon {
          display: inline;
          position: relative;
          top: -2PX;
          left: 4PX;
        }
        &.info {
          background-image: url(~@/assets/images/card-info-h5.png);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
        &.solution {
          background-image: url(~@/assets/images/card-solution-h5.png);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
        &.contact {
          background-image: url(~@/assets/images/card-contact-h5.png);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
      .reward {
          // margin-top: 32PX;
          padding: 0 20PX;
        }
    }
    
  }
  </style>

  
<style>
.ca-img {
  width: 14PX;
}
.reward-img {
  width: 100%;
}
.bgDot {
  width: 16PX;
}
</style>


// WEBPACK FOOTER //
// src/views/home/components/dataComponent-h5.vue